
import { Component, Prop, Vue } from "vue-property-decorator";
import MatchInterface from "@/libs/model/MatchInterface";
import DateComponent from "@/components/Match/DateComponent.vue";
import MatchStatus from "@/components/Match/MatchStatus.vue";
import TeamsComponent from "@/components/Match/TeamsComponent.vue";
import TeamsScore from "@/components/Match/TeamsScore.vue";
import TeamsStage from "@/components/Match/TeamsStage.vue";
import lob from "lodash/object";

@Component({
  components: {
    DateComponent,
    MatchStatus,
    TeamsComponent,
    TeamsScore,
    TeamsStage
  }
})
export default class MatchInfo extends Vue {
  name: "MatchInfo";
  @Prop() matchdata: MatchInterface;
  @Prop() hidematchname: boolean;
  @Prop() blinkInterval: string;

  get blinkerClass(): string {
    if(this.blinkInterval){
      return `is-playing blink-me-${this.blinkInterval}`;
    }

    return "is-playing blink-me-medium";
  }

  get matchId(): string {
    return lob.get(this.matchdata, "matchInfo.id", "UNKNOWN");
  }

  get isLive(): Boolean {
    if(this.matchdata.liveData && this.matchdata.liveData.matchDetails && this.matchdata.liveData.matchDetails.matchStatus === "Playing"){
      return true;
    }
    return false;
  }
  get isAbandoned(): Boolean {
    if(this.matchdata.liveData && this.matchdata.liveData.matchDetails && this.matchdata.liveData.matchDetails.matchStatus === "Abandoned"){
      return true;
    }
    return false;
  }

  get venueName(): string {
    if(this.matchdata.liveData && this.matchdata.liveData.matchDetails && this.matchdata.liveData.matchDetails.matchStatus === "Postponed"){
      if(this.matchdata.matchInfo && (!this.matchdata.matchInfo.date || this.matchdata.matchInfo.date === "")) {
        return "";
      }
    }

    if(this.matchdata.liveData && this.matchdata.liveData.matchDetails && this.matchdata.liveData.matchDetails.matchStatus === "Abandoned"){
      return "";
    }

    return this.matchdata.matchInfo.venue.longName;

  }
   get isPostponed(): Boolean {
    if(this.matchdata.liveData && this.matchdata.liveData.matchDetails && this.matchdata.liveData.matchDetails.matchStatus === "Postponed"){
      if(this.matchdata.matchInfo && (!this.matchdata.matchInfo.date || this.matchdata.matchInfo.date === "")) {
        return true;
      }
    }
    return false;
  }
  get isRescheduled(): Boolean {
    if(this.matchdata.liveData && this.matchdata.liveData.matchDetails && this.matchdata.liveData.matchDetails.matchStatus === "Postponed"){
      if(this.matchdata.matchInfo && this.matchdata.matchInfo.date && this.matchdata.matchInfo.date !== "" ) {
        return true;
      }  
    }
    return false;
  }
}
